import React, { useEffect, useState } from 'react'

import { useQuery } from 'react-query'

import { Icon } from '../../../../components/Icon'
import { policyHeader, IncidentsHeadersAdmin } from '../../../../data/index'

import Pagination from '../../../../components/UI/Pagination'
import '../../../../App.css'
import Loading from '../../../../components/UI/Loading'
import { calculatePageCount, SeverityIcon } from './utils'
import { getIncidentData } from './apiCalls'
import { formatDate } from '../../../../utils/utils'

interface incidents {
  Report_No: number
  Status: string
  Severity_Level: string
  Incident_concerning: string
  Name_of_Employer: string
  Date_Reported: string
  Updated_At: string
  Created_By: string
  Updated_By: string
}

export interface FormData {
  candidate: string
  employer: string
  severity_level: string
  overview: string
  status: string
  receivedDate?: string
  receivedBy?: string

  supportRequirementRating?: string
  immediateActionTaken?: string
  furtherActionRequired?: string
  monitoringRequired?: string
  conclusionOfOutcome?: string
}

const IncidentGroupGovernor = () => {
  const [currentPage, setCurrentPage] = useState<number>(1)
  const [sortOrder, setSortOrder] = useState<{
    [key: string]: 'asc' | 'desc'
  }>({})

  const [sortBy, setSortBy] = useState<string>('reportNo')
  const [sortOrderValue, setSortOrderValue] = useState<string>('asc')

  const incidents = useQuery('policy', () =>
    getIncidentData(currentPage, sortBy, sortOrderValue)
  )

  const handleSort = (key: string) => {
    const newSortOrder = { ...sortOrder }
    if (newSortOrder[key] === 'asc' || newSortOrder[key] === undefined) {
      newSortOrder[key] = 'desc'
      setSortBy(key)
      setSortOrderValue('desc')
    } else {
      newSortOrder[key] = 'asc'
      setSortBy(key)
      setSortOrderValue('asc')
    }
    setSortOrder(newSortOrder)
  }

  useEffect(() => {
    incidents.refetch() // Refetch incidents when sortBy or sortOrderValue changes
  }, [sortBy, sortOrderValue])

  const handlePageChange = (pageNumber: number): void => {
    setCurrentPage(pageNumber)
    // You can add additional logic here, like fetching data for the new page
  }

  useEffect(() => {
    incidents.refetch()
  }, [currentPage])

  return (
    <div
      className={
        'flex flex-col gap-20 w-full bg-white  h-full rounded-3xl p-8  '
      }
    >
      <div className="flex flex-col gap-10 custom-scrollbar w-full relative h-full">
        <div className={'flex w-full justify-between items-start '}>
          <div className="flex-col w-[50%] gap-[20px]">
            <p className={'text-[18px] text-text2 font-bold '}>Incidents</p>
          </div>
        </div>
        {incidents.isLoading && (
          <div className="flex justify-center items-center h-screen">
            <Loading size="large" />
          </div>
        )}
        {!incidents.isLoading && (
          <div
            id={'#container'}
            className="w-full flex justify-center items-center "
          >
            {/* table component */}
            <div className="overflow-hidden rounded-[16px] w-full">
              <table className="rounded-[16px] overflow-hidden border w-full border-white">
                <thead>
                  <tr className="bg-gray2 cursor-pointer">
                    {IncidentsHeadersAdmin?.map((item, index: number) => {
                      return (
                        <th
                          key={index}
                          className={`w-1/8 px-4 py-3 text-left ${policyHeader?.length - 1 === index ? 'border-0 border-gray2' : 'border border-white'}`}
                        >
                          <div className="flex items-center">
                            <p className="text-text1 font-semibold text-sm flex-1">
                              {item.replace(/_/g, ' ')}
                            </p>
                            <div
                              onClick={() => {
                                let sortBy = ''
                                switch (item as keyof incidents) {
                                  case 'Report_No':
                                    sortBy = 'reportNo'
                                    break
                                  case 'Status':
                                    sortBy = 'status'
                                    break
                                  case 'Severity_Level':
                                    sortBy = 'severity_level'
                                    break
                                  case 'Incident_concerning':
                                    sortBy = 'candidate'
                                    break
                                  case 'Name_of_Employer':
                                    sortBy = 'employer'
                                    break
                                  case 'Date_Reported':
                                    sortBy = 'createdAt'
                                    break
                                  case 'Updated_At':
                                    sortBy = 'updatedAt'
                                    break
                                  case 'Created_By':
                                    sortBy = 'createdByName'
                                    break
                                  case 'Updated_By':
                                    sortBy = 'updatedByName'
                                    break
                                  default:
                                    break
                                }
                                handleSort(sortBy)
                              }}
                            >
                              <Icon
                                name={'IconChevronDown'}
                                width={16}
                                height={16}
                                strokeWidth={1}
                                stroke={'#67A5B9'}
                              />
                            </div>
                          </div>
                        </th>
                      )
                    })}
                  </tr>
                </thead>
                <tbody>
                  {incidents?.data?.data?.map((item, index: number) => (
                    <>
                      <tr key={index} className="bg-gray1">
                        {/* Example row */}
                        <td className="px-4 text-text1 font-medium text-[12px] h-[48px] py-2 border border-white">
                          {item?.reportNo}
                        </td>
                        <td className="px-4 text-text1 font-medium text-[12px] h-[48px] py-2 border border-white">
                          {item.status == 'open' ? (
                            <div className="px-[10px] flex justify-center items-center bg-lightGreen h-[28px] rounded-[100px]">
                              <p className="text-xs font-medium leading-5 text-text2">
                                {item.status}
                              </p>
                            </div>
                          ) : (
                            <div className="px-[10px] flex justify-center items-center bg-gray2 h-[28px] rounded-[100px]">
                              <p className="text-xs font-medium leading-5 text-text1">
                                {item.status}
                              </p>
                            </div>
                          )}
                        </td>
                        <td className="px-4 min-w-[135px] font-medium text-textError text-[12px] h-[48px] py-2 border border-white">
                          <SeverityIcon severity_level={item.severity_level} />
                        </td>
                        <td className="px-4 text-text1 font-medium text-[12px] h-[48px] py-2 border border-white">
                          <p className="text-xs text-text3 font-medium">
                            {item.candidate}
                          </p>
                        </td>
                        <td className="px-4 text-text1 font-medium text-[12px] h-[48px] py-2 border border-white">
                          <p className="text-xs text-text3 font-medium">
                            {item.employer}
                          </p>
                        </td>
                        <td className="px-4 text-text1 font-medium text-[12px] h-[48px] py-2 border border-white">
                          {formatDate(item?.createdAt || '')}
                        </td>

                        <td className="px-4 text-text1 font-medium text-[12px] h-[48px] py-2 border border-white">
                          <p className="text-xs text-text3 font-medium">
                            {item?.createdByName}
                          </p>
                        </td>
                        <td className="px-4 h-[48px] py-2 border border-white">
                          {item.updatedByName ? (
                            <p className="text-xs text-text1 font-medium">
                              {formatDate(item?.updatedAt || '')}
                            </p>
                          ) : (
                            <p className="text-xs text-text1 font-medium"></p>
                          )}
                        </td>
                        <td className="px-4 text-text1 font-medium text-[12px] h-[48px] py-2 border border-white">
                          <p className="text-xs text-text3 font-medium">
                            {item.updatedByName}
                          </p>
                        </td>
                      </tr>
                    </>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

        <div className="absolute bottom-[20px]">
          {/* Your content here */}
          <Pagination
            currentPage={currentPage}
            totalPages={calculatePageCount(Number(incidents?.data?.count) || 0)}
            onPageChange={handlePageChange}
          />
        </div>
      </div>
    </div>
  )
}

export default IncidentGroupGovernor
